<template>
  <div>
    <Card shadow>
      <Row :gutter="18">
        <Col span="7" style="display:none">
          <label style="display: flex; align-items: center">
            <span style="width: 80px">代理组:</span>
            <Select
              v-model="table.params.platids"
              placeholder="筛选所属分组"
              clearable
              multiple
              @on-change="updateSelect"
            >
              <Option
                v-for="(item, index) in plat_list"
                :value="item.id"
                :label="item.name"
                :key="index"
              >
                {{ item.name }}
                <span style="color: #bbb">({{ item.id }})</span>
              </Option>
            </Select>
          </label>
        </Col>
        <Col span="5">
          <label style="display: flex; align-items: center">
            <span style="width: 50px">代理:</span>
            <Select
              v-model="table.params.app_ids"
              placeholder="筛选代理"
              multiple
            >
              <Option
                v-for="(item, index) in app_list"
                v-show="
                  table.params.platids.length == 0 ||
                    table.params.platids.includes(item.platform)
                "
                :value="item.appid"
                :label="item.appName"
                :key="index"
              >
                {{ item.appName }}
                <span style="color: #bbb">({{ item.appid }})</span>
              </Option>
            </Select>
          </label>
        </Col>

        <Col span="4">
          <label style="display: flex; align-items: center">
            <span style="width: 110px">多语言分类:</span>
            <Select
                v-model="table.params.param._param.lang_type"
                filterable
                placeholder="选择多语言分类"
                clearable
            >
              <Option
                  v-for="item in globalLangList"
                  :value="item.value"
                  :label="item.name"
                  :key="item.value"
              >
                {{ item.name }}</Option
              >
            </Select>
          </label>
        </Col>

        <Col span="4">
          <label style="display: flex; align-items: center">
            <span style="width: 90px">货币分类:</span>
            <Select
                v-model="table.params.param._param.currency_type"
                filterable
                placeholder="选择货币分类"
                clearable
            >
              <Option
                  v-for="item in currencyList"
                  :value="item.currency"
                  :label="item.name"
                  :key="item.currency"
              >
                {{ item.name }}</Option
              >
            </Select>
          </label>
        </Col>

        <Col span="5">
          <label style="display: flex; align-items: center">
            <span style="width: 120px">统计时间:</span>
            <DatePicker
              type="daterange"
              v-model="select.dataTime"
              placeholder="统计时间"
              :options="dateOptions"
            ></DatePicker>
          </label>
        </Col>
      </Row>

      <Row :gutter="24" style="margin-top: 20px">
        <Col span="7" style="display: flex; justify-content: space-between">
          <Button
              type="primary"
              @click.native="TransTopReq()"
              :loading="loading"
              style="margin-right: 10px"
          >
            <span v-if="!loading">查询</span>
            <span v-else>loading..</span>
          </Button>

          <div>
            <Button
                type="primary"
                style="margin-right: 10px"
                @click.native="toExcel()"
            >
              导出Excel
            </Button>
            <Button type="primary" @click.native="toPdf()"> 导出PDF </Button>
          </div>
        </Col>
      </Row>
    </Card>
    <Table
      border
      :columns="table.columns"
      :data="table.data"
      :max-height="maxHeight"
      style="margin-top: 12px"
      @on-sort-change="sortChange"
      @on-expand="onExpand"
      :row-class-name="rowClassName"
      @on-row-click="handleTableClick"
      class="table-padding"
      @on-column-width-resize="widthResize"
    ></Table>
    <Table
      border
      :columns="copyColumn"
      :data="copyDataList"
      style="display: none"
      ref="tableRef"
      class="table-padding"
    ></Table>
    <Modal v-model="imageData.show" width="1000">
      <p slot="header" style="color: #1c2438; text-align: center">
        <span>{{ imageData.app_name }}</span>
      </p>
      <div>
        <Select
          class="select"
          v-model="imageData.checkColumn"
          style="width: 200px"
          @on-change="imageIndexChange"
        >
          <Option
            v-for="(item, index) in imageData.selectList"
            :value="item.key"
            :key="index"
            :label="item.name"
            >{{ item.name }}</Option
          >
        </Select>
        <ve-line
          :data="imageData.chartData"
          :settings="getChartSetting()"
          :colors="imageData.options"
          :extend="imageData.extend"
          :ref="imageData.ref"
        ></ve-line>
      </div>
    </Modal>
  </div>
</template>
<script>
import { Component, Vue, Watch } from 'vue-property-decorator'
import { TransTopReq } from '@/api/admin/risk'
import { getTableSetting, setTableSetting } from '@/libs/util'
import { tableSettingModel } from '@/libs/config'
import moment from 'moment'
import publicTable from '@/views/components/publicTable.vue'
import {mapState} from "vuex";
export default {
  name: 'dataRecord',
  components: { publicTable },
  data() {
    return {
      tableSetting: {},
      maxHeight: 720,
      loading: false,
      copyDataList: [],
      copyColumn: [],
      TransTopReqTimer: null,
      select: {
        dataTime: [this.getCurrentZeroDay(), this.getCurrentZeroDay()]
      },
      //columns配置参数
      columnConfig: {
        new_user_num: { name: '新增人数', tip: '筛选时间内,盘口新增注册人数' },
        // new_user_pay_num: {
        //   name: '新增转入人数',
        //   tip: '筛选时间内,盘口新增转入人数'
        // },
        // // zhuan_rate: { name: '新增转化率', tip: '筛选时间内,盘口新增转入人数 / 新增人数' },
        // pay_user_num: {
        //   name: '转入人数',
        //   tip: '筛选时间内,盘口转入人数；人数去重'
        // },
        // pay_sum: {
        //   name: '转入金额',
        //   tip: '统计盘口筛选时间内的转入金额',
        //   showTrend: true
        // },
        // pay_ave: { name: 'Arppu', tip: '统计盘口筛选时间内的【转入金额】/【转入人数】', showTrend: true },
        // pay_put_sum: { name: "充提差",tip: "(【转入金额】-【转出金额】)", },
        // pay_put_rate: { name: "转入转出比", tip: "(【转入金额】-【转出金额】) /【转入金额】", },
        // new_win_rate: { name: '营收比', tip: '统计盘口(【今日转入】-【今日转出】+【昨日余额】-【今日余额】) /【转入金额】' },
        bet_sum: { name: '投注金额', tip: '统计盘口筛选时间内的投注金额' },
        game_loss_sum: { name: '游戏盈亏', tip: '【投注金额】-【返奖金额】' },
        // bet_user_num:{ name:"投注人数", tip:"11"},
        user_point_sum: {
          name: '人均投注金额',
          tip: '【投注金额】/【投注人数】'
        },
        loss_bet_rate: {
          name: '盈亏投注比',
          tip: '统计盘口筛选时间内(【投注金额】-【返奖金额】) /【投注金额】'
        },
        // loss_pay_rate: {
        //   name: '盈亏转入比',
        //   tip: '统计盘口筛选时间内(【游戏盈亏】) /【转入金额】'
        // },
        // bet_pay_rate: {
        //   name: '投注转入比',
        //   tip: '统计盘口筛选时间内(【投注金额】/【转入金额】)',
        //   showTrend: true
        // },
        give_sum: { name: '赠送金额', tip: '赠送金额' },
        // send_total_percent_sum: { name: '佣金', tip: '统计盘口筛选时间内发放的佣金金额' },
        // give_pay_rate: { name: '赠送转入比', tip: '统计筛选时间内该盘口的【赠送总金额】/【转入总金额】' },
        // money_loss_rate: { name: '佣金转入比', tip: '统计筛选时间内盘口【佣金金额】/【转入总金额】' },
        // pay_winner_rate: { name: '转入赢家数占比', tip: '' },
        // money_win_rate: {
        //   name: '实钱赢家数占比',
        //   tip:
        //     '【实钱赢家数占比】=【实钱赢家数】/ (【实钱赢家数】+【实钱输家数】)'
        // },
        // offline_pay_rate: {
        //   name: '线下转入金额占比 ',
        //   tip: '显示线下转入金额占比大盘（转入金额 - 线上转入金额）/ 转入金额'
        // },
        // online_rate: {
        //   name: '线上转入订单成功率 '
        //   // tip:"筛选时间内,盘口线上转入订单成功率 = 成功转入订单数 / 提交转入订单数",
        // },
        // onlie_pay_rate: {
        //   name: '线上转入金额成功率 '
        //   // tip:"筛选时间内,盘口线上转入金额成功率 = 成功转入金额 / 提交转入订单金额",
        // }
      },
      expandId: null,
      imageData: {
        show: false,
        app_name: '',
        ref: 'vChartImage',
        checkColumn: 'new_user_num',
        options: ['#32CD32', 'rgb(244, 128, 36)'],
        extend: { series: { smooth: false } },
        chartSettings: { labelMap: {}, yAxisType: ['percent'] },
        selectList: [],
        chartData: {
          columns: ['time', 'new_user_num'],
          rows: []
        }
      },
      currentSortParam: {},
      table: {
        params: {
          mod: 'root',
          platid: 0,
          platids: [],
          app_id: 0,
          app_name: '',
          platform: 0,
          app_ids: [],
          param: {
            _mod: 'manager',
            _func: 'GetNewPlatfromData',
            _param: {
              platid: 0,
              app_id: 0,
              stime: 0,
              etime: 0,
              limit: 1000,
              general: -1,
              pack_no: -1,
              lang_type: '',
              currency_type: ''
            }
          }
        },
        data: [],
        children: [],
        columns1: [],
        columns: [],
        total: 0,
        pageSizes: [10, 20, 30, 40]
      }
    }
  },
  computed: {
    ...mapState({
      currencyList: (state) => state.app.globalCurrencyList,
    }),
  },
  methods: {
    //变化时变更配置
    getChartSetting() {
      if (
        this.imageData.checkColumn.includes('_rate') &&
        this.imageData.checkColumn != 'bet_pay_rate'
      ) {
        return this.imageData.chartSettings
      } else {
        return Object.assign({}, this.imageData.chartSettings, {
          yAxisType: ['normal']
        })
      }
    },
    //关闭定时器
    closeTimer() {
      this.loading = false
      clearTimeout(this.TransTopReqTimer)
      this.TransTopReqTimer = null
    },
    //批量请求开启定时器8秒超时
    openTimer() {
      this.closeTimer()
      this.loading = true
      this.TransTopReqTimer = setTimeout(() => {
        this.loading = false
      }, 6000)
    },
    toExcel() {
      let data = [...this.table.data]
      let arr = []
      for (let i in data) {
        let init = data[i]
        let item = this.copyData(init)
        let from = this.copyData(init.data || [])
        item.indexType = Number(i) + 1
        delete item.data
        arr.push(item)
        for (let k in from) {
          let temp = from[k]
          if (item.app_name === '合计' && Number(k) !== from.length - 1) {
            arr.push(temp)
          } else if(item.app_name !== '合计') {
            arr.push(temp)
          }
        }
      }
      let column = this.getColumn(true)
      column.pop()
      column.shift()
      this.copyDataList = arr
      this.copyColumn = column
      this.sortChangeByParams()
      this.$nextTick(async () => {
        await this.eleToExcel({
          data: arr,
          columns: column
        })
        this.copyDataList = []
        this.copyColumn = []
      })
    },
    toPdf() {
      let item = this.table.columns.pop()
      let item3 = this.table.columns1.pop()
      this.maxHeight = null
      try {
        for (let i in this.table.data) {
          this.$set(this.table.data[i], '_expanded', true)
        }
        this.$nextTick(async () => {
          await this.eleToPdf()
          this.maxHeight = 720
          for (let i in this.table.data) {
            this.$set(this.table.data[i], '_expanded', false)
          }
          this.table.columns.push(item)
          this.table.columns1.push(item3)
        })
      } catch (error) {
        for (let i in this.table.data) {
          this.$set(this.table.data[i], '_expanded', false)
        }
        this.table.columns.push(item)
        this.table.columns1.push(item3)
      }
    },
    getImageData(param) {
      let rows = []
      if (param.data) {
        rows = this.copyData(param.data)
        rows.reverse()
      }
      rows.forEach(el => {
        el.time = moment(el.itime * 1000)
          .locale('zh-cn')
          .format('YYYY-MM-DD')
        for (let i in el) {
          if (i.includes('_sum') || i == 'pay_ave') {
            el[i] = Number(this.getCustomFixed(el[i] / 10000))
          }
          if (i == 'bet_pay_rate') {
            el[i] = el[i] ? el[i].toFixed(2) : 0
          }
        }
      })
      this.imageData.chartData.rows = rows
      this.imageData.show = true
      this.imageData.app_name = param.app_name
      this.$nextTick(() => {
        this.$refs[this.imageData.ref].echarts.resize()
      })
    },

    async TransTopReq() {
      if (this.loading) return
      let [stime, etime] = this.select.dataTime
      this.table.params.param._param.stime = this.getSecond(stime)
      this.table.params.param._param.etime = this.getSecond(etime, false)
      this.openTimer()
      let allList = this.getAllHttpAppid(this.table.params)

      this.table.data = []
      let dateMap = {}
      let all = {
        app_id: -10,
        plat_form_name: '',
        app_name: '合计',
        new_user_num: 0,
        onlie_ok_pay_sum: 0, //线上成功转入金额
        onlie_sub_pay_sum: 0, //线上转入金额
        onlie_pay_rate: 0, //线上金额转入成功率
        no_filter_pay_user_num: 0,
        no_filter_bet_user_num: 0,
        new_user_pay_num: 0,
        pay_user_num: 0, //转入人数
        bet_user_num: 0, //投注人数
        put_sum: 0, //体现金额
        pay_sum: 0, //转入金额
        new_win_pay: 0, //
        pay_ave: 0, // 平均转入 arppu = 转入金额/转入人数
        pay_put_sum: 0,
        pay_put_rate: 0, //转入转出比 转入金额-转出金）/转入金额
        new_win_rate: 0, //营收比= 营收金额/转入金额
        bet_sum: 0, //投注金额
        game_loss_sum: 0, //游戏盈亏
        loss_bet_rate: 0, //盈亏投注比 【投注金额】-【返奖金额】）/【投注金额】；
        bet_pay_rate: 0, //投注转入比 【投注金额】/【转入金额】；
        give_sum: 0, //赠送金额
        hit_sum: 0, //返奖金额
        pay_winner: 0, //转入赢家人数
        pay_loser: 0, //转入输家数
        send_percent_sum: 0, // 团队佣金发送金额
        pay_winner_rate: 0, //转入赢家数占比
        money_win_rate: 0, //实钱赢家数占比
        send_total_percent_sum: 0, //佣金
        give_pay_rate: 0,
        loss_pay_rate: 0,
        offline_pay_rate: 0, //线下转入金额占比
        user_point_sum: 0, //人均投注金额
        money_win_user: 0, //实钱赢家数
        money_lose_user: 0, //实钱输家数
        money_loss_rate: 0, //佣金转入比  佣金/转入
        new_win_sum: 0, //营收金额=今日转入-今日转出+昨日余额-今日余额
        online_pay_all_num: 0, // 线上转入总订单数
        online_pay_success_num: 0, // 线上转入成功订单数
        zhuan_rate: 0 //新增转化率
      }
      let httpList = []
      let loadingArr = [...allList]
      for (let i = 0, len = allList.length; i < len; i++) {
        let app_id = allList[i]
        let app_name = ''
        let platid = 0
        let item = this.app_list.find(el => el.appid == app_id)
        if (item) {
          app_name = item.appName
          platid = item.platform
        }
        this.table.params.platid = platid
        this.table.params.app_id = app_id
        this.table.params.app_name = app_name
        this.table.params.param._param.app_id = app_id
        this.table.params.param._param.platid = platid
        let param = this.copyData(this.table.params)
        httpList.push(param)
      }
      // httpList.push(all)
      for (let s = 0; s < 5; s++) {
        this.toHttp(httpList, dateMap, all, loadingArr)
      }
    },
    async toHttp(httpList, dateMap, all, loadingArr) {
      if (httpList.length > 0) {
        let param = httpList[0]
        httpList.shift()
        TransTopReq(param)
          .then(res => {
            if (res._param) {
              res._param.isParent = true

              let newPayBet = res._param.data.reduce(
                (result, cur) => {
                  result.pay += cur.pay_user_num
                  result.bet += cur.bet_user_num
                  // cur.currency_type = res._param.currency_type
                  // cur.lang_type = res._param.lang_type
                  return result
                },
                { pay: 0, bet: 0 }
              )
              let params1 = this.copyData(param)
              params1.param._func = 'GetNewPlatfromPayOrderData'
              //获取用户转入行为数据
              TransTopReq(params1).then(res1 => {
                if (res1._param) {
                  let reapData = res1._param.data
                  let onlie_sub_pay_sum = 0
                  let all_onlie_ok_pay_sum = reapData.reduce((res, cur) => {
                    res += cur.onlie_ok_pay_sum
                    onlie_sub_pay_sum += cur.onlie_sub_pay_sum
                    return res
                  }, 0)
                  res._param.no_filter_pay_user_num = newPayBet.pay
                  res._param.no_filter_bet_user_num = newPayBet.bet
                  res._param.onlie_ok_pay_sum = all_onlie_ok_pay_sum
                  res._param.onlie_sub_pay_sum = onlie_sub_pay_sum
                  res._param.onlie_pay_rate = this.calcRate(
                    res._param.onlie_ok_pay_sum,
                    res._param.onlie_sub_pay_sum
                  )
                  res._param.pay_ave = this.calcRate(
                    res._param.pay_sum,
                    res._param.no_filter_pay_user_num
                  )
                  res._param.user_point_sum = this.calcRate(
                    res._param.bet_sum,
                    res._param.no_filter_bet_user_num
                  )
                  res._param.offline_pay_rate = this.calcRate(
                    res._param.pay_sum - res._param.onlie_ok_pay_sum,
                    res._param.pay_sum
                  )
                  let { app_id, platid, app_name } = param
                  Object.assign(res._param, {
                    app_id,
                    platid,
                    app_name
                  })
                  this.addAllDayItem(all, res._param)

                  res._param.money_loss_rate = this.calcRate(
                    res._param.send_total_percent_sum,
                    res._param.pay_sum
                  )
                  res._param.new_win_rate = this.calcRate(
                    res._param.new_win_sum,
                    res._param.new_win_pay
                  )
                  res._param.loss_pay_rate = this.calcRate(
                    res._param.game_loss_sum,
                    res._param.pay_sum
                  )
                  res._param.give_pay_rate = this.calcRate(
                    res._param.give_sum,
                    res._param.pay_sum
                  )
                  res._param.online_rate = this.calcRate(
                    res._param.online_pay_success_num,
                    res._param.online_pay_all_num
                  )
                  res._param.data = res._param.data.filter(el => el.time)
                  res._param.new_user_pay_num = 0
                  let data = res._param.data
                  if (data && data.length > 0) {
                    data.reverse()
                    res._param.data = data.reduce((child, cur, index) => {
                      //重新计算 累计合计
                      all.new_user_pay_num += cur.new_user_pay_num

                      //重新计算 app
                      res._param.new_user_pay_num += cur.new_user_pay_num

                      //重新计算当前项
                      cur.no_filter_pay_user_num = cur.pay_user_num
                      cur.no_filter_bet_user_num = cur.bet_user_num

                      cur.user_point_sum = this.calcRate(
                        cur.bet_sum,
                        cur.bet_user_num
                      )

                      let findData = reapData.find(
                        other =>
                          moment(cur.time).format('YYYY-MM-DD') ==
                          moment(other.time).format('YYYY-MM-DD')
                      ) || {
                        onlie_ok_pay_sum: 0,
                        onlie_pay_num_rate: 0,
                        onlie_sub_pay_sum: 0
                      }
                      cur.onlie_ok_pay_sum = findData.onlie_ok_pay_sum
                      cur.onlie_pay_num_rate = findData.onlie_pay_num_rate
                      cur.onlie_sub_pay_sum = findData.onlie_sub_pay_sum
                      cur.onlie_pay_rate = this.calcRate(
                        cur.onlie_ok_pay_sum,
                        cur.onlie_sub_pay_sum
                      )
                      cur.offline_pay_rate = this.calcRate(
                        cur.pay_sum - cur.onlie_ok_pay_sum,
                        cur.pay_sum
                      )
                      cur.money_loss_rate = this.calcRate(
                        cur.send_total_percent_sum,
                        cur.pay_sum
                      )
                      cur.loss_pay_rate = this.calcRate(
                        cur.game_loss_sum,
                        cur.pay_sum
                      )
                      cur.online_rate = this.calcRate(
                        cur.online_pay_success_num,
                        cur.online_pay_all_num
                      )
                      cur.give_pay_rate = this.calcRate(
                        cur.give_sum,
                        cur.pay_sum
                      )

                      let el = this.copyData(cur)

                      let plat_form_name = moment(el.time)
                        .locale('zh-cn')
                        .format('YYYY-MM-DD')
                      let dateItem = dateMap[el.time]
                      if (dateItem) {
                        this.addAllDayItem(dateItem, el, false)
                      } else {
                        el.plat_form_name = plat_form_name
                        dateMap[el.time] = el
                      }

                      if (cur.itime) {
                        let obj = {
                          plat_form_name: plat_form_name
                        }
                        if (index > 0) {
                          let item = res._param.data[index - 1]
                          this.mathTrend(obj, item, cur)
                        }
                        child.unshift(Object.assign(cur, obj))
                      }
                      return child
                    }, [])
                  } else {
                    delete res._param.data
                  }
                  res._param.zhuan_rate = res._param.new_user_num
                    ? res._param.new_user_pay_num / res._param.new_user_num
                    : 0
                  all.zhuan_rate = this.calcRate(
                    all.new_user_pay_num,
                    all.new_user_num
                  )
                  let newArray = [...this.table.data, res._param]

                  this.table.data = newArray
                }
                this.requestCallBack(loadingArr, dateMap, all, true)
                this.toHttp(httpList, dateMap, all, loadingArr)
              })
            }
          })
          .catch(err => {
            this.requestCallBack(loadingArr, dateMap, all)
            this.toHttp(httpList, dateMap, all, loadingArr)
          })
      }
    },
    getTrend(val1, val2) {
      return val1 < val2 ? 1 : val1 > val2 ? 2 : 3
    },
    //计算每日比例
    mathTrend(obj, item, cur) {
      obj.new_user_num_trend = this.getTrend(
        item.new_user_num,
        cur.new_user_num
      )
      obj.give_pay_rate_trend = this.getTrend(
        item.give_pay_rate,
        cur.give_pay_rate
      )

      obj.pay_user_num_trend = this.getTrend(
        item.pay_user_num,
        cur.pay_user_num
      )
      obj.loss_pay_rate_trend = this.getTrend(
        item.loss_pay_rate,
        cur.loss_pay_rate
      )

      obj.pay_sum_trend = this.getTrend(item.pay_sum, cur.pay_sum)
      obj.pay_ave_trend = this.getTrend(item.pay_ave, cur.pay_ave)

      obj.pay_put_rate_trend = this.getTrend(
        item.pay_put_rate,
        cur.pay_put_rate
      )

      obj.new_win_rate_trend = this.getTrend(
        item.new_win_rate,
        cur.new_win_rate
      )

      obj.bet_sum_trend = this.getTrend(item.bet_sum, cur.bet_sum)
      obj.game_loss_sum_trend = this.getTrend(
        item.game_loss_sum,
        cur.game_loss_sum
      )
      obj.loss_bet_rate_trend = this.getTrend(
        item.loss_bet_rate,
        cur.loss_bet_rate
      )
      obj.bet_pay_rate_trend = this.getTrend(
        item.bet_pay_rate,
        cur.bet_pay_rate
      )
      obj.give_sum_trend = this.getTrend(item.give_sum, cur.give_sum)
      obj.send_total_percent_sum_trend = this.getTrend(
        item.send_total_percent_sum,
        cur.send_total_percent_sum
      )
      obj.money_loss_rate_trend = this.getTrend(
        item.money_loss_rate,
        cur.money_loss_rate
      )
      obj.pay_winner_rate_trend = this.getTrend(
        item.pay_winner_rate,
        cur.pay_winner_rate
      )
      obj.money_win_rate_trend = this.getTrend(
        item.money_win_rate,
        cur.money_win_rate
      )
      obj.money_win_rate_trend = this.getTrend(
        item.money_win_rate,
        cur.money_win_rate
      )
      obj.online_rate_trend = this.getTrend(item.online_rate, cur.online_rate)
    },
    requestCallBack(list, dateMap, all, insert = false) {
      list.shift()
      if (insert) {
        let index = this.table.data.findIndex(el => el.app_id == -10)
        if (index != -1) this.table.data.splice(index, 1)
        if (this.table.data.length > 0) {
          let allValue = Object.values(dateMap)
          if (allValue.length > 0) {
            allValue.sort((a, b) => {
              return a.time > b.time ? 1 : -1
            })
            allValue.forEach((cur, index) => {
              if (index > 0) {
                let item = allValue[index - 1]
                let obj = {}
                this.mathTrend(obj, item, cur)
                Object.assign(cur, obj)
              }
            })
            allValue.reverse()
            all.data = allValue
          }
          this.table.data.push(all)
        }
      }
      if (list.length == 0) {
        this.closeTimer()
      }
    },

    //计算"和""比" 数据
    addAllDayItem(all, item, isAll = true) {
      if (!isAll) {
        all.new_user_pay_num += item.new_user_pay_num || 0
        all.zhuan_rate = this.calcRate(all.new_user_pay_num, all.new_user_num)
      }
      all.send_total_percent_sum += item.send_total_percent_sum || 0
      all.new_user_num += item.new_user_num || 0
      all.pay_user_num += item.pay_user_num || 0
      all.bet_user_num += item.bet_user_num || 0
      all.no_filter_pay_user_num += item.no_filter_pay_user_num
      all.no_filter_bet_user_num += item.no_filter_bet_user_num
      all.pay_sum += item.pay_sum || 0
      all.onlie_ok_pay_sum += item.onlie_ok_pay_sum || 0
      all.onlie_sub_pay_sum += item.onlie_sub_pay_sum || 0
      all.bet_sum += item.bet_sum || 0
      all.hit_sum += item.hit_sum || 0
      all.pay_put_sum += item.pay_put_sum || 0
      all.pay_winner += item.pay_winner || 0
      all.pay_loser += item.pay_loser || 0
      all.game_loss_sum += item.game_loss_sum || 0
      all.give_sum += item.give_sum || 0
      all.send_percent_sum += item.send_percent_sum || 0
      all.new_win_sum += item.new_win_sum || 0
      all.online_pay_all_num += item.online_pay_all_num || 0
      all.online_pay_success_num += item.online_pay_success_num || 0
      all.put_sum += item.put_sum || 0
      all.money_win_user += item.money_win_user || 0 //实钱赢家数
      all.money_lose_user += item.money_lose_user || 0
      all.new_win_pay = all.new_win_pay || 0
      all.new_win_pay += item.new_win_pay || 0
      all.user_point_sum = this.calcRate(
        all.bet_sum,
        all.no_filter_bet_user_num
      )
      all.online_rate = this.calcRate(
        all.online_pay_success_num,
        all.online_pay_all_num
      )
      all.give_pay_rate = this.calcRate(all.give_sum, all.pay_sum)
      all.bet_pay_rate = this.calcRate(all.bet_sum, all.pay_sum) //投注转入比
      all.pay_put_rate = this.calcRate(all.pay_sum - all.put_sum, all.pay_sum) //充提差比
      if (isAll) {
        all.new_win_rate = this.calcRate(all.new_win_sum, all.new_win_pay) //营收比
      } else {
        all.new_win_rate = this.calcRate(all.new_win_sum, all.pay_sum) //营收比
      }
      all.onlie_pay_rate = this.calcRate(
        all.onlie_ok_pay_sum,
        all.onlie_sub_pay_sum
      )
      all.offline_pay_rate = this.calcRate(
        all.pay_sum - all.onlie_ok_pay_sum,
        all.pay_sum
      ) //线下转入金额占比
      all.pay_ave = this.calcRate(all.pay_sum, all.no_filter_pay_user_num) // arppu
      all.money_loss_rate = this.calcRate(
        all.send_total_percent_sum,
        all.pay_sum
      ) //实钱盈亏比
      all.loss_bet_rate = this.calcRate(all.bet_sum - all.hit_sum, all.bet_sum) //盈亏投注比
      all.money_win_rate = this.calcRate(
        all.money_win_user,
        all.money_win_user + all.money_lose_user
      )
      all.pay_winner_rate = this.calcRate(
        all.pay_winner,
        all.pay_winner + all.pay_loser
      ) //转入赢家数占比
      all.loss_pay_rate = this.calcRate(all.game_loss_sum, all.pay_sum)
      all.zhuan_rate = this.calcRate(all.new_user_pay_num, all.new_user_num)
    },

    //获取显示趋势图标
    getTrendIcon(h, value) {
      if (!value) return
      return h('Icon', {
        props: {
          type: value > 1 ? 'md-arrow-down' : 'md-arrow-up',
          color: value > 1 ? '#32CD32' : 'red',
          size: 16
        },
        style: {
          marginLeft: '4px'
        }
      })
    },
    //分组变化清空盘口选择项
    updateSelect() {
      this.table.params.app_ids = []
    },
    //更改趋势图显示的字段
    imageIndexChange(val) {
      this.imageData.chartData.columns = [
        this.imageData.chartData.columns[0],
        val
      ]
      this.$refs[this.imageData.ref].echarts.resize()
    },
    sortChangeByParams() {
      if (this.currentSortParam.order) {
        let order = this.currentSortParam.order == 'desc' ? 1 : -1
        let key = this.currentSortParam.key
        this.copyDataList.sort((a, b) => {
          if (a.app_id == -10) return 1
          if (b.app_id == -10) return -1
          return a[key] * order > b[key] * order ? -1 : 1
        })
      }
    },

    //table自定义排序方法
    sortChange(params) {
      this.currentSortParam = params
      this.table.data.filter((item, index) => {
        item['_expanded'] = false
        return item
      })
      let order = params.order == 'desc' ? 1 : -1
      let key = params.key
      this.table.data.sort((a, b) => {
        if (a.app_id == -10) return 1
        if (b.app_id == -10) return -1
        return a[key] * order > b[key] * order ? -1 : 1
      })
    },
    //获取表格cloumn isExpand:是否子数据
    getColumn(isExpand) {
      let arr = []
      for (let key in this.columnConfig) {
        let val = this.columnConfig[key]
        let item
        if (!!val.tip) {
          item = {
            key,
            align: 'center',
            sortable: 'custom',
            resizable: true,
            renderHeader: h => this.renderHeader(h, val.name, val.tip)
          }
        } else {
          item = {
            key,
            align: 'center',
            sortable: 'custom',
            resizable: true,
            title: val.name
          }
        }
        if (key.includes('_rate')) {
          Object.assign(item, {
            width: 150,
            render: (h, params) =>
              h('span', [
                h(
                  'span',
                  key == 'bet_pay_rate'
                    ? this.getCustomFixed(params.row[key])
                    : (params.row[key] * 100).toFixed(2) + '%'
                ),
                val.showTrend
                  ? this.getTrendIcon(h, params.row[key + '_trend'])
                  : null
              ])
          })
        } else if (key.includes('_num')) {
          Object.assign(item, {
            width: 150,
            render: (h, params) =>
              h('span', [
                h('span', params.row[key]),
                val.showTrend
                  ? this.getTrendIcon(h, params.row[key + '_trend'])
                  : null
              ])
          })
        } else if (key.includes('_sum') || key == 'pay_ave') {
          Object.assign(item, {
            width: 150,

            render: (h, params) =>
              h('span', [
                h('span', this.getCustomFixed(params.row[key] / 10000)),
                val.showTrend
                  ? this.getTrendIcon(h, params.row[key + '_trend'])
                  : null
              ])
          })
        }
        arr.push(item)
      }
      return [
        isExpand
          ? {
              type: 'expand',
              width: 38,
              align: 'center',
              render: (h, params) =>
                h(publicTable, {
                  props: {
                    row: params.row.data,
                    columns: this.table.columns1
                  }
                })
            }
          : {
              width: 38,
              align: 'center'
            },
        {
          type: 'index',
          title: '序号',
          width: 40,
          align: 'center',
          indexMethod: (el, val) => {
            if (!el.isParent) {
              return ''
            } else {
              return el._index != null ? el._index + 1 : el.indexType || ''
            }
          }
        },
        {
          key: 'app_name',
          align: 'center',
          width: 100,
          resizable: true,
          renderHeader: (h, params) =>
            this.renderHeader(h, '平台名称', '显示统计信息对应的盘口名称')
        },
        {
          key: 'plat_form',
          align: 'center',
          width: 100,
          resizable: true,
          render: (h, params) => {
            if (params.row.plat_form_name)
              return h('span', params.row.plat_form_name)
            let item = this.getAppInfo(params.row)
            return h('span', item ? item.name : '')
          },
          renderHeader: (h, params) =>
            this.renderHeader(h, '所属分组', '显示对应盘口的所属平台')
        },
        {
          key: 'lang_type',
          align: 'center',
          width: 100,
          resizable: true,
          renderHeader: (h, params) =>
              this.renderHeader(h, '多语言分类', '显示对应盘口所使用的语言'),
          render: (h, params) => {
            return h('span', this.langFilter(params.row.lang_type))
          },
        },
        {
          key: 'currency_type',
          align: 'center',
          width: 100,
          resizable: true,
          renderHeader: (h, params) =>
              this.renderHeader(h, '货币分类', '显示对应盘口所使用的货币'),
        },
        ...arr,
        isExpand
          ? {
              title: '趋势图',
              align: 'center',
              width: 105,
              key: 'option',
              resizable: true,
              render: (h, params) => {
                return h(
                  'Button',
                  {
                    props: {
                      size: 'small',
                      type: 'primary'
                    },
                    on: {
                      click: () => {
                        this.getImageData(params.row)
                      }
                    }
                  },
                  '趋势图'
                )
              }
            }
          : {
              title: '趋势图',
              align: 'center',
              resizable: true,
              key: 'option',
              width: 105
            }
      ]
    },
    //点击展开事件
    onExpand(row, status) {
      this.expandId = row.app_id
      let expand = this.table.data.find(el => el._expanded)
      if (expand) this.$set(expand, '_expanded', false)
      if (status) {
        let newEx = this.table.data.find(el => el.app_id == row.app_id)
        if (newEx) this.$set(newEx, '_expanded', true)
      }
    },
    //点击行事件
    handleTableClick(row, index) {
      let data = this.table.data[index]
      if (this.expandId == row.app_id) {
        if (!data._expanded) this.expandId = null
      } else {
        this.table.data[index]['_userCheck'] = !data._userCheck
      }
    },
    //设置行选中样式
    rowClassName(row, index) {
      let data = this.table.data[index]
      if (data._userCheck || data._expanded) return 'user-table-check'
      return ''
    },
    initFunc() {
      this.table.params.platids = [this.getinitPlatId()]
      this.TransTopReq()
    },
    getAppInfo(item) {
      return this.plat_list.find(el => el.id == item.platid) || {}
    },
    widthResize(val, val1, val2) {
      let { key } = val2
      this.tableSetting[key] = val
      setTableSetting(tableSettingModel.dataRecord, this.tableSetting)
      let find = this.table.columns1.find(el => el.key == key)
      if (find) {
        find.width = val
      }
    },
    initTableSetting() {
      //配置table
      this.table.columns1 = this.getColumn(false)
      this.table.columns = this.getColumn(true)
      //获取保存的配置并设置
      this.tableSetting = getTableSetting(tableSettingModel.dataRecord)
      this.table.columns1.forEach(element => {
        if (element.key && this.tableSetting[element.key]) {
          element.width = this.tableSetting[element.key]
        }
      })
      this.table.columns.forEach(element => {
        if (element.key && this.tableSetting[element.key]) {
          element.width = this.tableSetting[element.key]
        }
      })
    },
    imageDataShow() {
      if (!this.imageData.show) {
        this.imageData.checkColumn = 'new_user_num'
        this.imageData.chartData.columns = ['time', 'new_user_num']
      }
    }
  },
  watch: {
    'imageData.show': function() {
      this.imageDataShow()
    }
  },
  created() {
    this.initTableSetting()
    for (let key in this.columnConfig) {
      this.imageData.chartSettings.labelMap[key] = this.columnConfig[key][
        'name'
      ]
      this.imageData.selectList.push({
        key: key,
        name: this.columnConfig[key]['name']
      })
    }
    this.initFunc()
  }
}
</script>
<style lang="less" scoped>
.btn_batch {
  margin-right: 12px;
}
</style>
